import { createSelector } from 'reselect';

const selectPhonePe = (state: any) => state.phonePe;

export const selectPhonePeCurrentItem = createSelector([selectPhonePe], (phonePe) => phonePe.current);

export const selectPhonePeListItems = createSelector([selectPhonePe], (phonePe) => phonePe.list);

export const selectPhonePeItemById = (itemId: any) =>
    createSelector(selectPhonePeListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPhonePeQueryItems = createSelector([selectPhonePe], (phonePe) => phonePe.query);

export const selectPhonePeCreatedItem = createSelector([selectPhonePe], (phonePe) => phonePe.create);

export const selectPhonePeUpdatedItem = createSelector([selectPhonePe], (phonePe) => phonePe.update);

export const selectPhonePeReadItem = createSelector([selectPhonePe], (phonePe) => phonePe.read);

export const selectPhonePeDeletedItem = createSelector([selectPhonePe], (phonePe) => phonePe.delete);

export const selectPhonePeSearchedItems = createSelector([selectPhonePe], (phonePe) => phonePe.search);

export const selectPhonePeItemsCount = createSelector([selectPhonePe], (phonePe) => phonePe.count);

export const selectPhonePeItemsFilter = createSelector([selectPhonePe], (phonePe) => phonePe.filter);